export const Filters = {
  labelFilterPyxisCreation: 'Data de Criação Pyxis',
  labelFilterDisponibility: 'Data de Disponibilidade',
  labelFilterState: 'Estado Movimenta'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/Filters.js